import { Box, Button, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";

interface ExistedIdentifierModalProps {
  showExistedIdentifierModal: boolean;
  setShowExistedIdentifierModal: React.Dispatch<React.SetStateAction<boolean>>;
  identifier: string;
}

const ExistedIdentifierModal = ({
  showExistedIdentifierModal,
  setShowExistedIdentifierModal,
  identifier,
}: ExistedIdentifierModalProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <Modal
      open={showExistedIdentifierModal}
      onClose={() => setShowExistedIdentifierModal(false)}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 350,
            minWidth: 350,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>{labels.existed_identifier}</p>
          <p style={{ textAlign: "center", marginTop: 16 }}>
            <span style={{ fontWeight: "bold" }}>{identifier}</span>
          </p>
          <div className="w-100 flex gap-4 mt-10">
            <Button
              variant="contained"
              fullWidth
              onClick={() => setShowExistedIdentifierModal(false)}
            >
              {labels.accept}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default ExistedIdentifierModal;
